/**
 * Copies the important properties of a passed in event and returns
 * the new object
 */
export default (e) => {
  let eventCopy = { ...e };
  eventCopy.target = { ...e.target };
  return eventCopy;
}